<template>
  <q-btn-dropdown
    :color="color"
    :text-color="textColor"
    :label="label"
    :align="align"
    :flat="flat"
    :outline="outline"
    :rounded="rounded"
    :icon="icon"
    :icon-right="iconRight"
    :size="size"
    :stretch="stretch"
    dropdown-icon="keyboard_arrow_down"
    no-caps
    unelevated
    padding="7px 16px"
    v-model="currentValue"
  >
    <template v-slot:label>
      <div class="text-left">
        <slot name="label"></slot>
      </div>
    </template>
    <template v-if="$slots.default">
      <slot />
    </template>
    <List v-else>
      <template v-for="item in items">
        <Item v-bind:key="item.key" clickable v-close-popup @click="onClick(item)" :to="item.to">
          <ItemSection avatar v-if="item.icon">
            <Icon :name="item.icon" />
          </ItemSection>
          <ItemSection>
            <ItemLabel>{{ item.label }}</ItemLabel>
          </ItemSection>
        </Item>
        <Separator v-bind:key="`${item.key}-separator`" v-if="item.separator" />
      </template>
    </List>
    <slot name="footer"></slot>
  </q-btn-dropdown>
</template>

<script>
import List from './List.vue';
import Item from './Item.vue';
import ItemSection from './ItemSection.vue';
import ItemLabel from './ItemLabel.vue';
import Icon from './Icon.vue';
import Separator from './Separator.vue';

export default {
  name: 'ButtonDropdown',
  components: {
    List,
    Item,
    ItemSection,
    ItemLabel,
    Icon,
    Separator,
  },
  props: {
    label: String,
    customLabel: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
    },
    color: {
      type: String,
      default: 'primary',
      validator: (color) =>
        ['primary', 'secondary', 'tertiary', 'standard', 'input'].includes(color),
    },
    flat: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    stretch: {
      type: Boolean,
      default: false,
    },
    align: String,
    icon: String,
    iconRight: String,
    size: {
      type: String,
      default: 'md',
      validator: (size) =>
        ['xs', 'sm', 'md', 'lg', 'xl', 'small', 'medium', 'large'].includes(size),
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    textColor() {
      return this.color === 'standard' ? 'black' : '';
    },
    currentValue: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    onClick(item) {
      if (item.onClick) item.onClick();
      else this.$emit('click', item.key);
    },
  },
};
</script>
<style lang="scss" scoped>
.text-left::v-deep {
  overflow: hidden;
  .q-item__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.q-item__section--avatar ::v-deep {
  min-width: auto;
}
</style>
